import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Link } from "react-router-dom";
import { Prompt } from "react-router";

import { connect } from "react-redux";

import { icons } from "constants/icons";
import { Can } from "constants/abilityContext";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  datePickerProps,
  selectProps,
  dateFormat,
  displayErrorContext,
  renderProjectSelectOption,
  LastProject,
} from "utils";

import { Header, Logo, DocumentsList, Weather } from "components";
import {
  Icon,
  Input,
  notification,
  Button,
  Checkbox,
  Select,
  DatePicker,
  Divider,
  Spin,
} from "antd";

import {
  tailgateService,
  weatherService,
  projectService,
  userService,
  selectService,
} from "services";

// Composant qui affiche le tableau des risks/means.
const RiskTable = (props) => {
  var { sections } = props;

  var columns = sections.map((section) => {
    const selected = props.openedRisks.indexOf(section.id) !== -1;
    if (section.means.length === 0) return;

    return (
      <div className="risk-row" key={section.id}>
        <div
          className={"risk-header " + (selected ? "selected" : "")}
          onClick={() => props.handleRiskToggle && props.handleRiskToggle(section)}
        >
          <img src={process.env.PUBLIC_URL + "/images/risks/" + (section.picto || "default.png")} />
          <h4>{section.label}</h4>
        </div>

        <div className={"risks-list " + (selected ? "opened" : "")}>
          {section.means.map((r) => (
            <Checkbox key={r.id} value={r.id}>
              {r.label}
            </Checkbox>
          ))}
        </div>
      </div>
    );
  });

  return (
    <Checkbox.Group
      disabled={props.readonly ? true : false}
      value={props.value}
      onChange={(values) => props.onChange && props.onChange(values)}
    >
      {columns}
    </Checkbox.Group>
  );
};

// Composant de détails d'un modèle.
// Beaucoup d'optimisation possible (React Modeling 04h11 pour code optimisé et centralisé).
//
// Les fonctions suivantes sont implémentées :
// - fetchSelects()
//   Fetch les options des dropdowns avec le selectService.
// - formatTag()
//   Render le html approprié selon les clés données dans le html.
//   En read render du static, en edit ou create render des inputs.
// - handleRiskToggle()
//   Gère le changement des means cochés.
// - handleChange()
//   Gère le changement d'une valeur.
// - handleSubmit()
//   Gère le submit du form, tant en edit qu'en create.
// - validateFields()
//   Valide les champs du form qui sont required, utilise la fonction validateProfileFields
//   de utils/form.
// - render()
//   Render commun pour les 3 modes, la gestion des inputs se fait dans
//   formatTag(), mais les conditions plus générales se font directement dans render()
class TailgatePage extends Component {
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;

    this.state = {
      tailgate: {
        __type: "Tailgate",
        id: id,
        published: 0,
        documents: [],
      },
      uploading: false,
      errors: {},
      edited: false,
      means: [],
      projects: [],
      licenses: [],

      openedRisks: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRiskToggle = this.handleRiskToggle.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    const { tailgate } = this.state;
    const { edit, create } = this.props;
    const _ = this;

    this.doclist = React.createRef();

    if (!create) {
      tailgateService
        .get(tailgate.id)
        .then((result) => {
          result.means = result.means.map((m) => m.id);
          if (edit) result.licenses = result.licenses.map((l) => l.id);
          result.meteo = JSON.parse(result.meteo);
          this.setState({ tailgate: { ...tailgate, ...result } });

          this.fetchMeans();
        })
        .catch((e) => {
          history.push("/tailgates");
        });
    } else {
      this.setState({ tailgate: { ...tailgate, date: new Date() } });
      this.fetchMeans();

      weatherService
        .get()
        .then((result) => {
          this.setState((prev) => {
            return {
              tailgate: { ...prev.tailgate, meteo: result }
            }
          });
        });
    }

    if (edit || create) this.fetchSelects();
  }

  componentWillReceiveProps(nextProps) {
    const { projects, means } = this.state;
    const { edit, create } = nextProps;
    if ((!projects || projects.length === 0) && (edit || create)) this.fetchSelects();
    if (!means || means.length === 0) this.fetchMeans();
  }

  async fetchSelects() {
    const licenses = await selectService.listLicenses();
    const projects = await projectService.list({
      order_by: "code,label",
      order_direction: "ASC,ASC",
      disabled: 0,
    });

    this.setState({ licenses, projects });
  }

  async fetchMeans() {
    const selects = await selectService.listForPage("tailgate");
    const selectedMeans = this.state.tailgate.means || [];
    var openedRisks = [];

    var groupedMeans = selects.Risk.map((risk) => {
      risk.means = selects.Mean.filter((m) => m.risk_id == risk.id);
      risk.means.map((m) => {
        if (selectedMeans.indexOf(m.id) !== -1) openedRisks.push(risk.id);
      });

      return risk;
    });

    this.setState({ means: groupedMeans, openedRisks });
  }

  formatTag(key, fixed = false, label = "") {
    const { tailgate, errors } = this.state;
    const { edit, create } = this.props;

    if ((!edit && !create) || (fixed && edit)) {
      if (
        (key === "details" || key === "sse_action") &&
        tailgate[key] &&
        typeof tailgate[key] === "string"
      )
        tailgate[key] = tailgate[key].split("\n").map((item, key) => (
          <Fragment key={key}>
            {item}
            <br />
          </Fragment>
        ));

      switch (key) {
        case "project_id":
          return tailgate.project ? (
            <Link to={`/projects/${tailgate.project_id}`}>
              <Icon type={icons.project} />
              {`${tailgate.project.label}`}
            </Link>
          ) : (
            ""
          );
        case "means":
          return (
            <RiskTable
              readonly
              sections={this.state.means}
              openedRisks={this.state.openedRisks}
              value={tailgate[key]}
            />
          );
        case "licenses":
          return (
            <b>
              {(tailgate[key] || []).map((i) => (
                <i key={i.id} className="list-item">
                  {i.label}
                </i>
              ))}
            </b>
          );
        case "date":
          return (
            <>
              <Icon type="calendar" />
              {tailgate[key] ? moment(tailgate[key]).format(dateFormat) : null}
            </>
          );
        case "published":
          return (
            <>
              <Icon type="form" />
              {tailgate[key] ? "Publié" : "En attente de publication"}
            </>
          );
        case "nb_contractor":
        case "nb_subcontractor":
          return (
            <b>
              <Icon type="user" />
              {tailgate[key] || 0}
            </b>
          );
        case "nb_hours_contractor":
        case "nb_hours_subcontractor":
          return <b>{tailgate[key] || 0}h</b>;
        default:
          return <b>{tailgate[key]}</b>;
      }
    }

    var input;
    if (key === "date") {
      input = (
        <DatePicker
          name={key}
          value={tailgate[key] ? moment(tailgate[key]) : null}
          onChange={(date, value) => this.handleChange(date, key)}
          {...datePickerProps()}
        />
      );
    } else if (key === "project_id") {
      var list = this.state.projects,
        computeLabel = renderProjectSelectOption;

      var options = list.map((t) => (
        <Select.Option key={t.id} value={t.id}>
          {computeLabel(t)}
        </Select.Option>
      ));

      input = (
        <Select
          value={tailgate[key]}
          onChange={(value) => this.handleChange(value, key)}
          {...selectProps()}
        >
          {options}
        </Select>
      );
    } else if (key === "means") {
      input = (
        <RiskTable
          sections={this.state.means}
          openedRisks={this.state.openedRisks}
          handleRiskToggle={this.handleRiskToggle}
          value={tailgate[key]}
          onChange={(values) => this.handleChange(values, key)}
        />
      );
    } else if (key === "licenses") {
      var options = this.state.licenses.map((l) => ({
        label: l.label,
        value: l.id,
      }));

      input = (
        <Checkbox.Group
          options={options}
          value={tailgate[key]}
          onChange={(values) => this.handleChange(values, key)}
        ></Checkbox.Group>
      );
    } else {
      var Tag = key === "details" || key === "sse_action" ? Input.TextArea : Input;

      input = (
        <Tag
          name={key}
          value={tailgate[key]}
          prefix={key === "nb_contractor" || key === "nb_subcontractor" ? <Icon type="user" /> : ""}
          suffix={key === "nb_hours_contractor" || key === "nb_hours_subcontractor" ? "h" : ""}
          onChange={(e) => this.handleChange(e.target.value, key)}
        />
      );
    }

    var error = errors && errors[key];
    return <span className={error ? "error-wrap" : ""}>{input}</span>;
  }

  handleChange(value, key) {
    this.setState({
      tailgate: { ...this.state.tailgate, [key]: value },
      edited: true,
    });
  }

  handleRiskToggle(risk) {
    var { openedRisks } = this.state;
    const index = openedRisks.indexOf(risk.id);

    if (index === -1) {
      this.setState({ openedRisks: [...openedRisks, risk.id] });
    } else {
      openedRisks.splice(index, 1);
      var { means: selectedMeans } = this.state.tailgate;
      const toRemoveMeans = risk.means.map((m) => m.id);
      selectedMeans = (selectedMeans || []).filter((m) => toRemoveMeans.indexOf(m) === -1);
      this.setState({
        openedRisks,
        tailgate: { ...this.state.tailgate, means: selectedMeans },
        edited: true,
      });
    }
  }

  handleSubmit(publish = false) {
    if (publish && !this.validateFields()) return;

    var tailgate = { ...this.state.tailgate };
    if (publish) tailgate.published = 1;

    const { edit, create } = this.props;

    var func;

    if (edit) {
      func = tailgateService.update;
    } else if (create) {
      func = tailgateService.create;
      tailgate.user_id = this.props.userId;
      tailgate.meteo = JSON.stringify(tailgate.meteo);
    }

    delete tailgate.documents;

    const errorNotif = (e) => {
      this.setState({ uploading: false });
      notification.open({
        message: "Une erreur s'est produite",
        description: "Veuillez réessayer ou contacter un administrateur.",
        placement: "bottomRight",
      });
    };

    this.setState({ uploading: true }, () => {
      func(tailgate)
        .then((n) => {
          this.doclist.current
            .executeActions(n.id, "Tailgate")
            .then(() => {
              notification.open({
                message: "Enregistrement effectué",
                description: "Vos changements ont été enregistrés avec succès.",
                placement: "bottomRight",
              });

              this.setState({
                tailgate: { ...tailgate, ...n },
                edited: false,
                uploading: false,
              });
              LastProject.set(tailgate?.project_id);
              history.replace(`/tailgates/${n.id}`);
            })
            .catch((e) => errorNotif(e));
        })
        .catch((e) => errorNotif(e));
    });
  }

  validateFields() {
    const { tailgate } = this.state;
    const { edit, create } = this.props;

    // var fields = ['project_id', 'date', 'nb_contractor', 'nb_subcontractor', 'nb_hours_contractor', 'nb_hours_subcontractor', 'details', 'signature']
    var fields = ["project_id", "date", "details", "signature"];
    var validation = validateProfileFields(tailgate, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { tailgate, errors, uploading } = this.state;
    const { edit, create } = this.props;

    var mode = "read",
      pageTitle = "Détails d'un tailgate",
      header = `Tailgate ${tailgate.code ? tailgate.code : ""}`,
      bread = [{ to: "/tailgates", text: "Liste des tailgates" }, { text: tailgate.code }];

    if (edit) {
      mode = "edit";
      pageTitle = "Édition d'un tailgate";
      bread = [
        { to: "/tailgates", text: "Liste des tailgates" },
        { to: `/tailgates/${tailgate.id}`, text: tailgate.code },
        { text: "Édition" },
      ];
    } else if (create) {
      mode = "create";
      pageTitle = "Création d'un tailgate";
      header = "Nouveau tailgate";
      bread = [{ to: "/tailgates", text: "Liste des tailgates" }, { text: "Création" }];
    }

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Logo className="print-logo" colors />
        <Header title={header} bread={bread} />

        <div className={`tailgate-page main-content profile-content ${mode}`}>
          <Can do={mode} on={tailgate}>
            <Spin
              indicator={<Icon type="loading" spin style={{ fontSize: "52px" }} />}
              spinning={uploading}
            >
              <ul className="tags">
                {mode === "read" && (
                  <>
                    <li>{this.formatTag("project_id")}</li>
                    <li className="alt">{this.formatTag("date")}</li>
                  </>
                )}
                {mode !== "create" && <li className="alt">{this.formatTag("published", true)}</li>}
              </ul>

              <div className={"profile-main-content " + mode}>
                {mode !== "read" && (
                  <div className="intro-block">
                    <div className="ctn">
                      <label>Projet :</label>
                      {this.formatTag("project_id")}
                    </div>

                    <div className="ctn">
                      <label>Date :</label>
                      {this.formatTag("date")}
                    </div>
                  </div>
                )}

                <Weather weatherData={tailgate.meteo} />

                <div className="workers-block">
                  <div className="ctn">
                    {this.formatTag("nb_contractor")}
                    <span className="mult-sign">x</span>
                    {this.formatTag("nb_hours_contractor")}
                    <label>(CLB)</label>
                  </div>

                  <div className="ctn">
                    {this.formatTag("nb_subcontractor")}
                    <span className="mult-sign">x</span>
                    {this.formatTag("nb_hours_subcontractor")}
                    <label>(Sous-contractants)</label>
                  </div>
                </div>

                <Divider />

                <div className="details-block">
                  <h3>Prévu aujourd'hui</h3>
                  <div className="ctn">{this.formatTag("details")}</div>
                </div>

                <Divider />

                <div className="details-block">
                  <h3>Action SSE et coordination</h3>
                  <div className="ctn">{this.formatTag("sse_action")}</div>
                </div>

                <Divider />

                <div className="risks-block">
                  <h3>Risques et moyens de prévention</h3>
                  <div className="ctn">{this.formatTag("means")}</div>
                </div>

                <Divider />

                <div className="licenses-block">
                  <h3>Permis</h3>
                  <div className="ctn">{this.formatTag("licenses")}</div>
                </div>

                <DocumentsList
                  displaySignatures
                  ref={this.doclist}
                  documents={tailgate.documents}
                  editable={edit || create}
                  handleChange={this.handleChange}
                />

                <div className="ctn signature">
                  <label>Initiales :</label>
                  {this.formatTag("signature")}
                </div>
              </div>

              {(edit || create) && (
                <Fragment>
                  {displayErrorContext(errors)}

                  <div className="buttons">
                    <Button type="link" onClick={() => history.goBack()}>
                      Annuler
                    </Button>
                    {edit ? (
                      tailgate.published ? (
                        <Button
                          type="primary"
                          disabled={!this.state.edited}
                          onClick={() => this.handleSubmit(true)}
                        >
                          Enregistrer les changements
                        </Button>
                      ) : (
                        <>
                          <Button type="primary grey" onClick={() => this.handleSubmit()}>
                            Brouillon
                          </Button>
                          <Button type="primary" onClick={() => this.handleSubmit(true)}>
                            Publier le tailgate
                          </Button>
                        </>
                      )
                    ) : (
                      <>
                        <Button type="primary grey" onClick={() => this.handleSubmit()}>
                          Brouillon
                        </Button>
                        <Button type="primary" onClick={() => this.handleSubmit(true)}>
                          Publier le tailgate
                        </Button>
                      </>
                    )}
                  </div>

                  <Prompt
                    when={this.state.edited}
                    message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                  />
                </Fragment>
              )}

              {!edit && !create && (
                <Can do="edit" on={tailgate}>
                  <div className="buttons">
                    <Button type="link" onClick={() => window.print()}>
                      Imprimer
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => history.push("/tailgates/" + tailgate.id + "/edit")}
                    >
                      Éditer ce tailgate
                    </Button>
                  </div>
                </Can>
              )}
            </Spin>
          </Can>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.user.infos.id,
  };
};

export default connect(mapStateToProps, null)(TailgatePage);
